import TrendsLineChart from 'components/trends-line-chart/trends-line-chart.component';

const LocationLoyaltyTrendsLineChart = () => {
  return (
    <TrendsLineChart
      queryName="locationsTrends"
      data-testid="LocationLoyaltyTrendsLineChart.IncLineChart"
    />
  );
};

export default LocationLoyaltyTrendsLineChart;
